export enum ArticleTypes {
  ORIGINAL_ARTICLES = 'Original Articles',
  VARIATIONS = 'Variations'
}
